const blockedElements="script,style,iframe,object,embed,link,meta,form,input,button,textarea,select";

export function sanitizeDocumentHtml(html:string){
  const document=new DOMParser().parseFromString(html,"text/html");
  document.querySelectorAll(blockedElements).forEach(element=>element.remove());
  document.querySelectorAll("*").forEach(element=>{
    for(const attribute of Array.from(element.attributes)){
      const name=attribute.name.toLowerCase();
      const value=attribute.value.trim().toLowerCase();
      if(name.startsWith("on")||name==="style"||((name==="href"||name==="src")&&value.startsWith("javascript:")))element.removeAttribute(attribute.name);
    }
    if(element instanceof HTMLAnchorElement){
      element.target="_blank";
      element.rel="noopener noreferrer";
    }
  });
  return document.body.innerHTML;
}
